export interface OnFocusEventDTO {
    Id: string,
    Source: FocusEventSource
  }
    
  export enum FocusEventSource {
    ContactCenter,
    CRM
  }